<template>
  <button
  :disabled="disabled"
  class="submit-button"
  @click="$emit('handleSubmit')"
  >提交信息，去开店</button>
</template>

<script>
export default {
  name: 'SubmitButton',
  mixins: [],
  components: {},
  props: {
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.submit-button{
  width: auto;
  height: calc(var(--raito) * 47px);
  background-image: linear-gradient(90deg, #1FE8E4 0%, #CCED66 100%);
  border-radius: calc(var(--raito) * 5px);
  border:none;
  font-family: PingFangSC-Medium;
  font-size: calc(var(--raito) * 15px);
  color: #1A2431;
}
.submit-button:active{
  opacity: 0.7;
}
.submit-button:disabled{
  opacity: 0.5;
}
</style>